"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.885 16.1979L21.1571 6.83049C20.5746 4.82667 19.3053 3.06606 17.5513 1.82887C15.7974 0.591687 13.6594 -0.0509783 11.4778 0.00316084C9.29619 0.0573 7.19627 0.805132 5.51226 2.12764C3.82824 3.45014 2.65691 5.27132 2.18468 7.30131L0.0747682 16.3479C-0.0273252 16.7862 -0.0248349 17.2407 0.0820552 17.6779C0.188945 18.1152 0.397507 18.524 0.692355 18.8741C0.987202 19.2243 1.36081 19.507 1.78562 19.7012C2.21042 19.8955 2.67558 19.9964 3.14678 19.9965H6.93119C7.172 21.1264 7.81537 22.1422 8.75231 22.8718C9.68924 23.6014 10.8621 24 12.0722 24C13.2823 24 14.4552 23.6014 15.3921 22.8718C16.329 22.1422 16.9724 21.1264 17.2132 19.9965H20.8539C21.3387 19.9963 21.8169 19.8894 22.2513 19.6841C22.6856 19.4788 23.0643 19.1807 23.3578 18.813C23.6513 18.4453 23.8516 18.018 23.9433 17.5644C24.0349 17.1108 24.0153 16.6432 23.886 16.1979H23.885ZM12.0722 21.9957C11.4235 21.9932 10.7915 21.7997 10.2627 21.4419C9.73381 21.084 9.33391 20.5792 9.11769 19.9965H15.0267C14.8105 20.5792 14.4106 21.084 13.8817 21.4419C13.3529 21.7997 12.7209 21.9932 12.0722 21.9957ZM21.688 17.6024C21.5901 17.726 21.4632 17.8261 21.3175 17.8947C21.1717 17.9633 21.0112 17.9984 20.8486 17.9973H3.14678C2.98968 17.9972 2.83459 17.9636 2.69295 17.8988C2.55132 17.8341 2.42676 17.7398 2.32847 17.623C2.23018 17.5063 2.16067 17.37 2.12507 17.2242C2.08947 17.0784 2.08869 16.9268 2.12278 16.7807L4.23269 7.73415C4.60447 6.14096 5.52456 4.7119 6.84669 3.67414C8.16882 2.63637 9.81711 2.04947 11.5295 2.00673C13.242 1.96399 14.9202 2.46786 16.2976 3.43824C17.6749 4.40863 18.6723 5.78983 19.1311 7.36229L21.859 16.7297C21.9035 16.8779 21.9113 17.0338 21.8816 17.1853C21.8519 17.3368 21.7856 17.4796 21.688 17.6024Z",
    fill: fill
  }));
};

exports["default"] = _default;